import React, { useEffect, useRef, useState } from "react";

import "./rcstyles.css";
import {
  Icon,
  LoadingIndicator,
  Typography,
} from "@anchor/react-components/dist/lib/components";
import { McTooltip, McIcon } from "@maersk-global/mds-react-wrapper/components-core";
import RootCauseIdentification from "./RootCauseIdentification/RootCauseIdentification";
import Collaborators from "../Collaborators/Collaborators";
import Comments from "../Comments/Comments";
import RcModal from "../RootCause/RcModal";
import { Col, Row } from "react-bootstrap";
import PhotoUploadModal from "../PhotoUploadModal/PhotoUploadModal";
import UseHandleFileUpload from "../../Utils/UseHandleFileUpload";
import { useMsal } from "@azure/msal-react";
import PhotoPreviewModal from "../PhotoPreviewModal/PhotoPreviewModal";

import UserInfo from "../../context/UserAccessContext";
import { useCallback } from "react";
import { ImageServices } from "../../services/imageServices";
import { TicketValidationServices } from "../../services/ticketValidationServices";
import { PostmortemServices } from "../../services/postmortemServices";
// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";
import { useLocation } from "react-router-dom";

const Loading = () => {
  return (
    <LoadingIndicator
      appearance="default"
      fit="large"
      id="testing"
      label="Fetching images, Please Wait..."
      variant="spinner"
      style={{ background: "none" }}
    />
  );
};

const IsLocked = ({ field, lockedFields, graphData }) => {
  if (!lockedFields || Object.keys(lockedFields).length === 0) return null;
  const lockedField = lockedFields.find(
    (lockedField) =>
      lockedField.fieldName === field &&
      lockedField.lockedBy !== graphData.username
  );
  return (
    <div>
      {lockedField ? (
        <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
          {lockedField.lockedBy} is Editing..
        </div>
      ) : null}
    </div>
  );
};

// Rows for the earlier-incidents editor; falls back to the flat incidentId/problemId for state saved before the list existed.
const initialReferencesList = (state) => {
  if (Array.isArray(state?.pastReferencesList) && state.pastReferencesList.length > 0) {
    return state.pastReferencesList.map((reference) => ({
      incidentId: reference.incidentId || "",
      problemId: reference.problemId || "",
      description: reference.description || "",
    }));
  }
  return state?.incidentId || state?.problemId
    ? [{ incidentId: state.incidentId || "", problemId: state.problemId || "", description: state.description || "" }]
    : [];
};

function RootCause(props) {
  const [rcData, setRcData] = useState({
    cause: props.RootCauseState.cause || "",
    rootCauseCode: {
      id: props.RootCauseState.rootCauseCode || "",
      label: props.RootCauseState.rootCauseCode || "",
      value: props.RootCauseState.rootCauseCode || "",
    },
    rootCauseSubCode: {
      id: props.RootCauseState.rootCauseSubCode || "",
      label: props.RootCauseState.rootCauseSubCode || "",
      value: props.RootCauseState.rootCauseSubCode || "",
    },
    subCategory:
      props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory
        ? {
            id:
              props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory,
            label:
              props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory,
            value:
              props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory,
          }
        : null,
    // changeRelated: props.RootCauseState.changeRelated,
    causedByChangeNumber: props.RootCauseState.causedByChangeNumber || "",

    causedByVendor: {
      id: props.RootCauseState.causedByVendor || "",
      label: props.RootCauseState.causedByVendor || "",
      value: props.RootCauseState.causedByVendor || "",
    },
    vendorDetails: props.RootCauseState.vendorDetails && ["Azure", "Kyndryl", "OBS", "TCS"].includes(props.RootCauseState.vendorDetails) 
      ? props.RootCauseState.vendorDetails 
      : props.RootCauseState.vendorDetails ? "Other" : "",
    customVendorName: props.RootCauseState.vendorDetails && !["Azure", "Kyndryl", "OBS", "TCS"].includes(props.RootCauseState.vendorDetails)
      ? props.RootCauseState.vendorDetails
      : "",

    tags: [],
    changedFileds: { ...props.changedFields },
    lockedFields: [...props.lockedFields],
    impactedByChange:
      props.RootCauseState.impactedByChange === "true" || props.RootCauseState.impactedByChange === true
        ? true
        : null,
    // changeIsRequired: props.RootCauseState.changeIsRequired || false,
  });

  const [recurrenceData, setRecurrenceData] = useState({
    description: props.RecurrenceState.description || "",
    recurrence: props.RecurrenceState.recurrence || "",
    count: props.RecurrenceState.count || "",
    incidentId: props.RecurrenceState.incidentId || "",
    problemId: props.RecurrenceState.problemId || "",
    pastReferencesList: initialReferencesList(props.RecurrenceState),
    recurringIssue:
      props.RecurrenceState.recurringIssue === true || props.RecurrenceState.recurringIssue === "true"
        ? true
        : null,
  });

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [photosFor, setPhotosFor] = useState("cause");
  const [photoModal, setPhotoModal] = useState(false);
  const [imageToPreview, setImageToPreview] = useState({
    preview: "",
    fileName: "",
  });
  const [impactedByChange, setImpactedByChange] = useState(
    // Convert string "true"/"false" to boolean; keep null when unset
    props.RootCauseState.impactedByChange === "true" || props.RootCauseState.impactedByChange === true
      ? true
      : null
  );
  const [rcModal, setRcModal] = useState(false);
  const rcSavingRef = useRef(false);
  const [recurrenceIsRequired, setRecurrenceIsRequired] = useState(
    props.RecurrenceState.recurringIssue === true || props.RecurrenceState.recurringIssue === "true"
      ? true
      : null
  );
  const [previewModal, setPreviewModal] = useState(false);
  const { instance, accounts } = useMsal();

  const [
    rootCauseIdentificationUploadedImages,
    setRootCauseIdentificationUploadedImages,
  ] = useState([]);

  const [fetchAgain, setFetchAgain] = useState(false);
  const { userIsAdmin, graphData } = UserInfo();
  
  // Debug log for fetchAgain changes
  useEffect(() => {
    console.log('[RootCause] fetchAgain state changed to:', fetchAgain);
  }, [fetchAgain]);

  const [modalsOpen, setModalsOpen] = useState({
    rootCause: false,
    rootCauseIdentification: false,
    recovery: false,
    recurrence: false,
    rootCauseImageModal: false,
    rootCauseIdentificationImageModal: false,
  });

  // const { broadCastChangeIsRequired, broadCastRecurringIssue } = useWebSocket();
  const broadCastChangeIsRequired = null; // WebSocket disabled
  const broadCastRecurringIssue = null; // WebSocket disabled
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const postmortemID = params.get("postmortemID");

  useEffect(() => {
    if (props.RootCauseState) {
      setRcData((prevRcData) => {
        // Preserve existing local changedFields when updating from props
        const existingChangedFields = prevRcData?.changedFileds || {};

        return {
          cause: props.RootCauseState.cause || "",
          rootCauseCode: {
            id: props.RootCauseState.rootCauseCode || "",
            label: props.RootCauseState.rootCauseCode || "",
            value: props.RootCauseState.rootCauseCode || "",
          },
          rootCauseSubCode: {
            id: props.RootCauseState.rootCauseSubCode || "",
            label: props.RootCauseState.rootCauseSubCode || "",
            value: props.RootCauseState.rootCauseSubCode || "",
          },
          subCategory:
            props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory
              ? {
                  id:
                    props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory,
                  label:
                    props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory,
                  value:
                    props.RootCauseState.subCategory || props.RootCauseState.rootCauseSubCategory,
                }
              : null,
          tags: props.RootCauseState.tags.map((tag) => {
            return { id: tag, label: tag, value: tag };
          }),
          causedByChangeNumber: props.RootCauseState.causedByChangeNumber || "",
          causedByVendor: {
            id: props.RootCauseState.causedByVendor || "",
            label: props.RootCauseState.causedByVendor || "",
            value: props.RootCauseState.causedByVendor || "",
          },
          vendorDetails: props.RootCauseState.vendorDetails && ["Azure", "Kyndryl", "OBS", "TCS"].includes(props.RootCauseState.vendorDetails) 
            ? props.RootCauseState.vendorDetails 
            : props.RootCauseState.vendorDetails ? "Other" : "",
          customVendorName: props.RootCauseState.vendorDetails && !["Azure", "Kyndryl", "OBS", "TCS"].includes(props.RootCauseState.vendorDetails)
            ? props.RootCauseState.vendorDetails
            : "",
          // Preserve local changedFields by merging with incoming props

          changedFileds: { ...props.changedFields },

          lockedFields: [...props.lockedFields],

          impactedByChange:
            props.RootCauseState.impactedByChange === "true" || props.RootCauseState.impactedByChange === true
              ? true
              : null,
        };
      });

      // Convert string "true"/"false" to boolean
      setImpactedByChange(
        props.RootCauseState.impactedByChange === "true" || props.RootCauseState.impactedByChange === true
          ? true
          : null
      );
    }

    if (props.RecurrenceState) {
      setRecurrenceData((prevRecurrenceData) => {
        // Preserve existing local changedFields
        const existingChangedFields = prevRecurrenceData?.changedFields || {};

        return {
          description: props.RecurrenceState.description || "",
          recurrence: props.RecurrenceState.recurrence || "",
          count: props.RecurrenceState.count || "",
          incidentId: props.RecurrenceState.incidentId || "",
          problemId: props.RecurrenceState.problemId || "",
          pastReferencesList: initialReferencesList(props.RecurrenceState),
          recurringIssue:
            props.RecurrenceState.recurringIssue === true || props.RecurrenceState.recurringIssue === "true"
              ? true
              : null,
          changedFields: {
            ...props.changedFields,
          },
        };
      });
      // if(props.RecurrenceState.recurringIssue){
      //   setRecurrenceIsRequired(true);
      // }
      // if (props.RecurrenceState.incidentId) {
      //   setRecurrenceIsRequired(true);
      // }
      if (props.RootCauseState.causedByChangeNumber) {
        setImpactedByChange(true);
      }
    }

    return () => {};
  }, [
    props.RootCauseState,
    props.RecurrenceState,
    props.RootCauseState.cause,
    props.RootCauseState.rootCauseCode,
    props.RootCauseState.rootCauseSubCode,
    props.RootCauseState.causedByVendor,
    props.RootCauseState.causedByChangeNumber,
    props.RootCauseState.vendorDetails,
    props.RootCauseState.tags,
    props.RecurrenceState.description,
    props.RecurrenceState.recurrence,
    props.RecurrenceState.count,
    props.RecurrenceState.incidentId,
    props.RecurrenceState.problemId,
    props.RecurrenceState.recurringIssue,
  ]);

  // console.log("RECURRENCE STATE ", recurrenceIsRequired, props.RecurrenceState)

  const [loadingImage, setLoadingImage] = useState({
    rootCause: false,
    rootCauseIdentification: false,
  });

  const [errorInFetchingImages, setErrorInFetchingImages] = useState({
    rootCauseImages: false,
    rootCauseIdentificationImages: false,
  });

  const { getImage } = ImageServices();
  const { validateChangeTicket, validateIncidentTicket } =
    TicketValidationServices();

  const fetchAndSetImages = useCallback(
    async (setterFunction, tag) => {
      console.log('[RootCause] Starting fetchAndSetImages for tag:', tag, 'incidentID:', props.incidentID);
      setLoadingImage((currentLoadingStates) => {
        return {
          ...currentLoadingStates,
          [tag]: true,
        };
      });
      setErrorInFetchingImages((currentErrorStates) => {
        let key = tag + "images";
        return {
          ...currentErrorStates,
          [key]: false,
        };
      });
      try {
        const images = await getImage([], props.incidentID, tag);
        console.log('[RootCause] Fetched images:', images?.length || 0, 'images for tag:', tag, 'actual images:', images);
        setterFunction(images);
        console.log('[RootCause] Set state with images, array length:', images?.length);
      } catch (error) {
        console.error("Error fetching images:", error);
        setErrorInFetchingImages((currentErrorStates) => {
          let key = tag + "Images";
          return {
            ...currentErrorStates,
            [key]: true,
          };
        });
      } finally {
        setLoadingImage((currentLoadingStates) => {
          return {
            ...currentLoadingStates,
            [tag]: false,
          };
        });
      }
    },
    [props.incidentID, instance, accounts]
  );
  useEffect(() => {
    console.log('[RootCause useEffect] Triggered - fetchAgain:', fetchAgain, 'incidentID:', props.incidentID, 'currentStep:', props.currentStep);
    if (props.incidentID && props.currentStep === 1) {
      console.log('[RootCause useEffect] Calling fetchAndSetImages for rootCauseIdentification');
      fetchAndSetImages(
        setRootCauseIdentificationUploadedImages,
        "rootCauseIdentification"
      );
    } else {
      console.log('[RootCause useEffect] Skipping - condition not met');
    }
  }, [fetchAgain, fetchAndSetImages, props.incidentID, props.currentStep]);

  const [timer, setTimer] = useState(null);
  const [validating, setValidating] = useState({
    changeId: false,
    incidentId: false,
  });
  const [invalidTicket, setInvalidTicket] = useState({
    changeId: { inValid: false, invalidMessage: "" },
    incidentId: { inValid: false, invalidMessage: "" },
  });

  useEffect(() => {
    if (rcData?.causedByChangeNumber && impactedByChange && rcModal) {
      clearTimeout(timer);
      setTimer(
        setTimeout(() => {
          checkIfChNoIsValid(rcData.causedByChangeNumber);
        }, 1000)
      );
    }
  }, [rcData.causedByChangeNumber, impactedByChange]);

  useEffect(() => {
    if (recurrenceData?.incidentId && recurrenceIsRequired && rcModal) {
      clearTimeout(timer);
      setTimer(
        setTimeout(() => {
          checkIfIncidentNoIsValid(recurrenceData?.incidentId);
        }, 1000)
      );
    }
  }, [recurrenceData?.incidentId, recurrenceIsRequired]);

  const checkIfChNoIsValid = async (changeNumber) => {
    if (changeNumber) {
      try {
        setValidating((current) => ({ ...current, changeId: true }));
        setInvalidTicket((current) => ({
          ...current,
          changeId: { inValid: false, invalidMessage: "" },
        }));
        const data = await validateChangeTicket(changeNumber);

        if (data) {
          setInvalidTicket((current) => ({
            ...current,
            changeId: { inValid: false, invalidMessage: "" },
          }));
        }
      } catch (error) {
        console.error("Error in validating change number", error);
        setInvalidTicket((current) => ({
          ...current,
          changeId: { inValid: true, invalidMessage: "Invalid ticket Id" },
        }));
      } finally {
        setValidating((current) => ({ ...current, changeId: false }));
      }
    }
  };

  const checkIfIncidentNoIsValid = async (incidentId) => {
    if (incidentId) {
      try {
        setValidating((current) => ({ ...current, incidentId: true }));
        setInvalidTicket((current) => ({
          ...current,
          incidentId: { inValid: false, invalidMessage: "" },
        }));
        const data = await validateIncidentTicket(incidentId);
        if (data) {
          setInvalidTicket((current) => ({
            ...current,
            incidentId: { inValid: false, invalidMessage: "" },
          }));
        }
      } catch (error) {
        console.error("Error in validating incident number", error);
        setInvalidTicket((current) => ({
          ...current,
          incidentId: { inValid: true, invalidMessage: "Invalid ticket Id" },
        }));
      } finally {
        setValidating((current) => ({ ...current, incidentId: false }));
      }
    }
  };

  //HANDLING ROOT CAUSE DATA
  /************************************************************************* */

  useEffect(() => {
    setRcData((prevState) => ({
      ...prevState,
      changedFileds: { ...props.changedFields },
    }));
  }, [props.changedFields]);

  useEffect(() => {
    setRecurrenceData((prevState) => ({
      ...prevState,
      changedFields: { ...props.changedFields },
    }));
  }, [props.changedFields]);

  // Suggested past incidents for the Recurrence "Yes" prompt — reuses the same
  // recurrence-analysis endpoint as the AI Analysis tab instead of a separate API.
  const { getRecurrenceAnalysisStatus, triggerRecurrenceAnalysis, recordRecurrenceFeedback } = PostmortemServices();
  const [recurrenceSuggestions, setRecurrenceSuggestions] = useState({ status: "NOT_STARTED" });
  const [referenceErrors, setReferenceErrors] = useState({});
  const referencesList = recurrenceData.pastReferencesList || [];

  // The flat incidentId/problemId stay in sync with the first filled row for validation and older readers.
  const applyReferencesList = (list) => {
    const primary = list.find((reference) => reference.incidentId) || list[0] || {};
    setRecurrenceData((prev) => ({
      ...prev,
      pastReferencesList: list,
      incidentId: primary.incidentId || "",
      problemId: primary.problemId || "",
      description: primary.description || "",
    }));
    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prevChangedFileds) => ({
        ...prevChangedFileds,
        pastReferencesList: true,
        incidentId: true,
        problemId: true,
      }),
    });
  };

  const loadRecurrenceSuggestions = async () => {
    if (!props.incidentID) return;
    try {
      const response = await getRecurrenceAnalysisStatus(props.incidentID);
      setRecurrenceSuggestions(response);
    } catch (error) {
      setRecurrenceSuggestions({ status: "FAILED", error: "Unable to load suggestions." });
    }
  };

  const findSimilarIncidents = async () => {
    if (!props.incidentID) return;
    try {
      await triggerRecurrenceAnalysis(props.incidentID);
      setRecurrenceSuggestions((current) => ({ ...current, status: "PENDING" }));
    } catch (error) {
      setRecurrenceSuggestions({ status: "FAILED", error: "Unable to start the search." });
    }
  };

  // Check once (don't auto-run the AI search) the first time "Yes" is selected,
  // so an existing result shows immediately without an extra click.
  useEffect(() => {
    if (userIsAdmin && recurrenceIsRequired && rcModal && recurrenceSuggestions.status === "NOT_STARTED") {
      loadRecurrenceSuggestions();
    }
  }, [userIsAdmin, recurrenceIsRequired, rcModal]);

  useEffect(() => {
    if (recurrenceSuggestions.status !== "PENDING" && recurrenceSuggestions.status !== "QUEUED") return undefined;
    const timer = window.setInterval(loadRecurrenceSuggestions, 8000);
    return () => window.clearInterval(timer);
  }, [recurrenceSuggestions.status, props.incidentID]);

  // Saves run one at a time (the server rewrites the whole feedback list) and never block the form.
  const feedbackQueue = useRef(Promise.resolve());

  const sendRecurrenceFeedback = (match, verdict, reason = "", note = "") => {
    const entry = {
      matchIncidentId: match.incidentId,
      matchPostMortemId: match.postMortemId,
      verdict,
      reason,
      note,
      source: "MODAL",
    };
    setRecurrenceSuggestions((current) => ({ ...current, feedback: [...(current.feedback || []), entry] }));

    feedbackQueue.current = feedbackQueue.current.then(async () => {
      try {
        const updated = await recordRecurrenceFeedback(props.incidentID, entry);
        setRecurrenceSuggestions(updated);
      } catch (error) {
        setRecurrenceSuggestions((current) => ({
          ...current,
          feedback: (current.feedback || []).filter((item) => item !== entry),
        }));
      }
    });
    return feedbackQueue.current;
  };

  // Only the incident id is prefilled: matches carry no problem id, and their postMortemId must not go in that field.
  const handleAcceptSuggestion = async (match) => {
    if (!referencesList.some((reference) => reference.incidentId === match.incidentId)) {
      const filled = referencesList.filter((reference) => reference.incidentId || reference.problemId);
      applyReferencesList([...filled, { incidentId: match.incidentId, problemId: "", description: "" }]);
    }
    await sendRecurrenceFeedback(match, "ACCEPTED");
  };

  const handleRejectSuggestion = async (match, reason, note) => {
    if (referencesList.some((reference) => reference.incidentId === match.incidentId)) {
      applyReferencesList(referencesList.filter((reference) => reference.incidentId !== match.incidentId));
    }
    await sendRecurrenceFeedback(match, "REJECTED", reason, note);
  };

  const handleAddReference = () =>
    applyReferencesList([...referencesList, { incidentId: "", problemId: "", description: "" }]);

  const handleReferenceChange = (index, field, value) => {
    if (field === "incidentId") {
      setReferenceErrors((current) => ({ ...current, [index]: "" }));
    }
    applyReferencesList(
      referencesList.map((reference, position) =>
        position === index ? { ...reference, [field]: value } : reference
      )
    );
  };

  const handleRemoveReference = (index) => {
    setReferenceErrors({});
    applyReferencesList(referencesList.filter((_, position) => position !== index));
  };

  const validateReference = async (index) => {
    const incidentId = referencesList[index]?.incidentId;
    const suggestedByAi = (recurrenceSuggestions?.result?.matches || []).some(
      (match) => match.incidentId === incidentId
    );
    if (!incidentId || suggestedByAi) {
      setReferenceErrors((current) => ({ ...current, [index]: "" }));
      return;
    }
    try {
      await validateIncidentTicket(incidentId);
      setReferenceErrors((current) => ({ ...current, [index]: "" }));
    } catch (error) {
      setReferenceErrors((current) => ({ ...current, [index]: "Invalid ticket Id" }));
    }
  };

  const handleRecurrenceChange = (value) => {
    const newRecurrenceRequired = typeof value === "string" ? value === "Yes" : !recurrenceIsRequired;
    setRecurrenceIsRequired(newRecurrenceRequired);
    setInvalidTicket((current) => ({
      ...current,
      incidentId: { inValid: false, invalidMessage: "Invalid ticket Id" },
    }));

    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prevChangedFileds) => ({
        ...prevChangedFileds, // Preserve all existing changedFileds values
        recurringIssue: true,
      }),
    });
    // broadCastRecurringIssue(postmortemID, !recurrenceIsRequired);
    // WebSocket disabled
  };

  const handleModal = (modalType) => {
    setRcModal(!rcModal);
    setModalsOpen((current) => {
      return {
        ...current,
        [modalType]: !current[modalType],
      };
    });
  };

  const handleChangeIsRequired = (value) => {
    const newImpactedByChange = typeof value === "string" ? value === "Yes" : !impactedByChange;
    setImpactedByChange(newImpactedByChange);
    setInvalidTicket((current) => ({
      ...current,
      changeId: { inValid: false, invalidMessage: "Invalid ticket Id" },
    }));

    // If changing to "No" (false), clear change-related fields only (NOT vendor info)
    if (!newImpactedByChange) {
      setRcData({
        ...rcData,
        causedByChangeNumber: "",
      });
    }

    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prevChangedFileds) => ({
        ...prevChangedFileds,
        impactedByChange: true,
        causedByChangeNumber: true,
        causedByVendor: true,
        vendorDetails: true,
      }),
    });

    // broadCastChangeIsRequired(postmortemID, !impactedByChange);
    // WebSocket disabled
  };

  const onSave = () => {
    rcSavingRef.current = true;

    // If "Other" is selected and customVendorName is provided, save customVendorName
    // Otherwise save vendorDetails
    let finalVendorDetails = rcData.vendorDetails === "Other" && rcData.customVendorName
      ? rcData.customVendorName
      : rcData.vendorDetails;

    // Clear vendor details if causedByVendor is "No"
    const vendorValue = rcData.causedByVendor?.value ?? "No";
    if (vendorValue === "No" || vendorValue === "NO") {
      finalVendorDetails = "";
    }

    // Handle change number - clear if impactedByChange is false
    let finalChangeNumber = impactedByChange ? rcData.causedByChangeNumber : "";

    // Vendor details are independent - always save causedByVendor value
    let finalCausedByVendor = vendorValue;

    // When switching recurrence to No, clear pastReferences fields
    const finalReferencesList = recurrenceIsRequired
      ? referencesList
          .map((reference) => ({
            incidentId: (reference.incidentId || "").trim(),
            problemId: (reference.problemId || "").trim(),
            description: reference.description || "",
          }))
          .filter((reference) => reference.incidentId || reference.problemId)
      : [];
    const primaryReference = finalReferencesList.find((reference) => reference.incidentId) || finalReferencesList[0] || {};
    const finalIncidentId = primaryReference.incidentId || "";
    const finalProblemId = primaryReference.problemId || "";
    const finalRecurrenceDesc = primaryReference.description || "";

    // Mark fields as changed to ensure they get persisted
    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "changedFileds",
      payload: (prevChangedFileds) => ({
        ...prevChangedFileds,
        causedByChangeNumber: true,
        causedByVendor: true,
        vendorDetails: true,
        impactedByChange: true,
        recurringIssue: true,
        recurrence: true,
        incidentId: true,
        problemId: true,
        pastReferencesList: true,
      }),
    });

    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "RootCauseState",
      payload: {
        cause: rcData.cause,
        rootCauseCode: rcData.rootCauseCode ? rcData.rootCauseCode.value : null,
        rootCauseSubCode: rcData.rootCauseSubCode ? rcData.rootCauseSubCode.value : null,
        subCategory: rcData.subCategory ? rcData.subCategory.value : null,
        changeRelated: rcData.changeRelated,
        causedByChangeNumber: finalChangeNumber,
        causedByVendor: finalCausedByVendor,
        tags: rcData.tags.map((tag) => tag.value),
        vendorDetails: finalVendorDetails,
        impactedByChange: String(impactedByChange), // Convert boolean to string for backend
        comments: props.RootCauseState.comments,
      },
    });

    props.dispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "RecurrenceState",
      payload: {
        description: finalRecurrenceDesc,
        recurrence: recurrenceData.recurrence,
        count: recurrenceData.count,
        incidentId: finalIncidentId,
        problemId: finalProblemId,
        pastReferencesList: finalReferencesList,
        recurringIssue: recurrenceIsRequired,
      },
    });

    // Incidents the reviewer typed in that the AI did not suggest count as misses for the effectiveness metrics.
    if (recurrenceSuggestions?.result && recurrenceIsRequired) {
      const suggested = (recurrenceSuggestions.result.matches || []).map((match) => match.incidentId);
      const alreadyRecorded = (recurrenceSuggestions.feedback || []).map((entry) => entry.matchIncidentId);
      const manual = finalReferencesList
        .map((reference) => reference.incidentId)
        .filter((incidentId) => incidentId && !suggested.includes(incidentId) && !alreadyRecorded.includes(incidentId));
      // Sequential: each call rewrites the whole feedback list server-side.
      manual.reduce(
        (previous, incidentId) => previous.then(() => sendRecurrenceFeedback({ incidentId }, "MANUAL_ADDED")),
        Promise.resolve()
      );
    }

    handleModal();

    if (props.onAutoSave) {
      setTimeout(() => { props.onAutoSave(); rcSavingRef.current = false; }, 100);
    } else {
      rcSavingRef.current = false;
    }
  };

  const handleRcData = (event, name) => {
    if (event.target) {
      const { name, value } = event.target;

      props.dispatch({
        type: "HANDLE EDITOR CHANGE",
        field: "changedFileds",
        payload: (prevChangedFileds) => ({
          ...prevChangedFileds, // Preserve all existing changedFileds values
          [name]: true,
        }),
      });

      setRcData({
        ...rcData,
        [name]: value,
      });
      if (name === "causedByChangeNumber") {
        checkIfChNoIsValid(value);
      }
      if (name === "customVendorName") {
        // When user types in custom vendor field, ensure vendorDetails is set to "Other"
        if (rcData.vendorDetails !== "Other") {
          setRcData(prev => ({
            ...prev,
            [name]: value,
            vendorDetails: "Other",
          }));
          props.dispatch({
            type: "HANDLE EDITOR CHANGE",
            field: "changedFileds",
            payload: (prevChangedFileds) => ({
              ...prevChangedFileds,
              vendorDetails: true, // Mark vendorDetails as changed too
            }),
          });
        }
      }
    } else {
      // console.log("event@486", event, name);
      // When category or sub-category changes we may need to clear dependent fields
      if (name === "rootCauseCode") {
        // Selecting a new category should clear any previously selected sub-category and sub-code
        setRcData({
          ...rcData,
          rootCauseCode: event,
          subCategory: null,
          rootCauseSubCode: null,
        });

        // Mark subCategory and rootCauseSubCode as changed so removal persists
        props.dispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prevChangedFileds) => ({
            ...prevChangedFileds,
            ["rootCauseCode"]: true,
            ["subCategory"]: true,
            ["rootCauseSubCode"]: true,
          }),
        });

        return;
      }

      if (name === "subCategory") {
        // Changing sub-category should clear sub-code
        setRcData({
          ...rcData,
          subCategory: event,
          rootCauseSubCode: null,
        });

        props.dispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prevChangedFileds) => ({
            ...prevChangedFileds,
            ["subCategory"]: true,
            ["rootCauseSubCode"]: true,
          }),
        });

        return;
      }

      if (name === "causedByVendor") {
        // If changing to "No", clear vendor details
        const newVendorDetails = (event.value === "No" || event.value === "NO") ? "" : rcData.vendorDetails;
        
        setRcData({
          ...rcData,
          causedByVendor: event,
          vendorDetails: newVendorDetails,
          customVendorName: "", // Also clear custom vendor name
        });

        props.dispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prevChangedFileds) => ({
            ...prevChangedFileds,
            ["causedByVendor"]: true,
            ["vendorDetails"]: true,
          }),
        });

        return;
      }

      setRcData({
        ...rcData,
        [name]: event,
      });
      props.dispatch({
        type: "HANDLE EDITOR CHANGE",
        field: "changedFileds",
        payload: (prevChangedFileds) => ({
          ...prevChangedFileds, // Preserve all existing changedFileds values
          [name]: true,
        }),
      });
    }
  };

  const handleRecurreceData = (event, name) => {
    if (event.target) {
      const { name, value } = event.target;

      setRecurrenceData({
        ...recurrenceData,
        [name]: value,
      });
      props.dispatch({
        type: "HANDLE EDITOR CHANGE",
        field: "changedFileds",
        payload: (prevChangedFileds) => ({
          ...prevChangedFileds, // Preserve all existing changedFileds values
          [name]: true,
        }),
      });
    } else {
      setRecurrenceData({
        ...recurrenceData,
        [name]: event,
      });
      props.dispatch({
        type: "HANDLE EDITOR CHANGE",
        field: "changedFileds",
        payload: (prevChangedFileds) => ({
          ...prevChangedFileds, // Preserve all existing changedFileds values
          [name]: true,
        }),
      });
    }
  };

  ///********************************************************************************  */

  //HANDLING FILE UPLOAD
  ///********************************************************************************  */
  const handlePhotoModalClose = () => {
    setPhotoModal(false);
    setModalsOpen((current) => {
      return {
        ...current,
        rootCauseImageModal: !current.rootCauseImageModal,
      };
    });
  };

  const hanldePreviewModal = () => {
    setPreviewModal(!previewModal);
  };

  const handlePhotoModalClick = (fotoFor) => {
    setPhotosFor(fotoFor);
    setPhotoModal(true);
    setModalsOpen((current) => {
      return {
        ...current,
        rootCauseImageModal: !current.rootCauseImageModal,
      };
    });
  };
  const { handleFiles, fileChange, deleteImage, previewImage } =
    UseHandleFileUpload(
      props.images,
      setError,
      setErrorMessage,
      photosFor,
      hanldePreviewModal,
      setImageToPreview,
      props.dispatch,
      props.imageFormData,
      "rootCause",
      setFetchAgain,
      props.incidentID
    );

  ///********************************************************************************  */

  const showComments = React.useMemo(() => {
    // First check if required objects exist
    if (!props.postmortemCurrentStatus || !props.RootCauseState) {
      return false;
    }

    // Check if comments should be shown based on postmortem status
    const notInInitialState =
      props.postmortemCurrentStatus.currentState &&
      props.postmortemCurrentStatus.currentState !== "DRAFT";

    // Check if NEW comments exist
    const hasNewComments =
      props.comments &&
      Array.isArray(props.RootCauseState.comments.NEW) &&
      props.RootCauseState.comments.NEW.length > 0;

    // Check for early state with DONE comments
    const inEarlyState =
      props.RootCauseState.curentState === "DRAFT";

    const hasDoneComments =
      props.RootCauseState.comments &&
      Array.isArray(props.RootCauseState.comments.DONE) &&
      props.RootCauseState.comments.DONE.length > 0;

    const hasReviewComments =
      props.RootCauseState.comments &&
      Array.isArray(props.RootCauseState.comments.INPROGRESS) &&
      props.RootCauseState.comments.INPROGRESS.length > 0;

    // Return true if either condition is met
    if (notInInitialState) return true;
    return (
      hasNewComments || (inEarlyState && (hasDoneComments || hasReviewComments))
    );
  }, [props.postmortemCurrentStatus, props.RootCauseState]);

  return (
    <div>
      <Row
        style={{
          gap:
            props.postmortemCurrentStatus.currentState === "DRAFT"
              ? "40px"
              : "",
        }}
        className="gx-4 mt-2"
      >
        <Col
          xxl={12}
          className="sixth-step rc-content-container scrollbar"
        >
          <RootCauseIdentification
            RootCauseIdentificationState={props.RootCauseIdentificationState}
            dispatch={props.dispatch}
            images={props.images}
            imageFormData={props.imageFormData}
            uploadedImages={
              rootCauseIdentificationUploadedImages
                ? rootCauseIdentificationUploadedImages
                : []
            }
            incidentID={props.incidentID}
            postmortemID={props.postmortemID}
            setFetchAgain={setFetchAgain}
            error={errorInFetchingImages.rootCauseIdentificationImages}
            loading={loadingImage.rootCauseIdentification}
            setModalIsOpening={setModalsOpen}
            changedFields={props.changedFields}
            lockedFields={props.lockedFields}
            postmortemIsIncompleteState={props.postmortemIsIncompleteState}
            onAutoSave={props.onAutoSave}
            aiInsight={props.aiInsight}
            aiDim={props.aiDim}
            rcCodeState={props.RootCauseState}
            rcRecurrenceState={props.RecurrenceState}
            onEditRootCauseCode={() => handleModal("rc")}
            portfolio={props.portfolio}
            mvcVulnerabilityRelated={props.mvcVulnerabilityRelated}
          />
        </Col>

        {/* <RecovModal
        handleRecovModal={handleRecovModal}
        recovModal={recovModal}
        recovery={recovery}
        setRecovery={setRecovery}
        onSave={onSave}
      /> */}


        <RcModal
          handleModal={handleModal}
          rcModal={rcModal}
          handleRcData={handleRcData}
          rcData={rcData}
          impactedByChange={impactedByChange}
          handleChangeIsRequired={handleChangeIsRequired}
          onSave={onSave}
          recurrenceIsRequired={recurrenceIsRequired}
          handleRecurrenceChange={handleRecurrenceChange}
          handleRecurreceData={handleRecurreceData}
          recurrenceData={recurrenceData}
          recurrenceSuggestions={recurrenceSuggestions}
          onFindSimilarIncidents={findSimilarIncidents}
          onAcceptSuggestion={handleAcceptSuggestion}
          onRejectSuggestion={handleRejectSuggestion}
          referencesList={referencesList}
          referenceErrors={referenceErrors}
          onAddReference={handleAddReference}
          onReferenceChange={handleReferenceChange}
          onRemoveReference={handleRemoveReference}
          onValidateReference={validateReference}
          showRecurrenceSuggestions={userIsAdmin}
          invalidTicket={invalidTicket}
          validating={validating}
          lockedFields={props.lockedFields}
          postmortemID={props.postmortemID}
          incidentID={props.incidentID}
          savingRef={rcSavingRef}
          portfolio={props.portfolio}
          mvcVulnerabilityRelated={props.mvcVulnerabilityRelated}
          dispatch={props.dispatch}
        />

        <PhotoUploadModal
          modalOpen={photoModal}
          handleModal={handlePhotoModalClick}
          handleModalClose={handlePhotoModalClose}
          files={props.images.rootCause[photosFor]}
          handleFiles={handleFiles}
          fileChange={fileChange}
          hanldePreviewModal={hanldePreviewModal}
          imageToPreview={imageToPreview}
          previewModal={previewModal}
          error={error}
          errorMessage={errorMessage}
          photoFor={photosFor}
        />

        <PhotoPreviewModal
          imageToPreview={imageToPreview}
          previewModal={previewModal}
          hanldePreviewModal={hanldePreviewModal}
        />
      </Row>
    </div>
    // </TourProvider>
  );
}

export default RootCause;
